module.exports = __webpack_public_path__ + "static/media/aac.26aa582d.svg";